import type { WarpGrepProvider } from '../../providers/types.js';

export async function toolGrep(
  provider: WarpGrepProvider,
  args: { pattern: string; path: string; glob?: string; context_lines?: number; case_sensitive?: boolean }
): Promise<{ output: string }> {
  const res = await provider.grep(args);
  
  // Return errors as output - let the model see and handle them
  if (res.error) {
    return { output: res.error };
  }
  
  if (!res.lines.length) {
    return { output: 'no matches' };
  }
  
  return { output: res.lines.join('\n') };
}

